<template>
  <div>

    <Navigation/>

    <div class="container is-fluid" style="margin-top:18px;">

      <nav class="level">

        <div class="level-left">
          <div class="level-item">
            <p class="subtitle is-3">
              <strong style="color:#fff;">Projects</strong>
            </p>
          </div>
        </div>

        <div class="level-right">

          <div class="level-item">
              <b-input placeholder="Search..."
                v-model="searchTerm"
                type="search"
                icon="magnify"
                @input="search">
              </b-input>
          </div>

          <div class="level-item">
            <button class="button field"
                :class="{'is-primary': selected}"
                @click="openProject(selected.id)"
                :disabled="!selected">
                <span>Open Project &nbsp;</span>
                <i class="mdi mdi-open-in-new"></i>
            </button>
          </div>

           <div class="level-item">
            <button class="button field"
                :class="{'is-info': selected}"
                @click="editProject(selected)"
                :disabled="!selected">
                <span>Edit Project &nbsp;</span>
                <i class="mdi mdi-border-color"></i>
            </button>
          </div>

           <div class="level-item">
            <button class="button field"
                :class="{'is-danger': selected}"
                @click="deleteProject(selected)"
                :disabled="!selected">
                <span>Delete Project &nbsp;</span>
                <i class="mdi mdi-delete"></i>
            </button>
          </div>

           <div class="level-item">
            <button class="button is-success"
                @click="newProjectDialog">
                <span>New Project &nbsp;</span>
                <i class="fa fa-plus"></i>
            </button>
          </div>

        </div>
      </nav>

      <b-table
        :data="isEmpty ? [] : filteredProjects"
        :selected.sync="selected"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :default-sort-direction="defaultSortDirection"
        default-sort="updated">
        <template slot-scope="props">

          <b-table-column field="name" label="Name" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="description" label="Description" sortable>
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="created" label="Created Date" sortable>
            {{ new Date(props.row.created).toUTCString() }}
          </b-table-column>

          <b-table-column field="updated" label="Modified Date" sortable>
            {{ (props.row.updated) ? new Date(props.row.updated).toUTCString() : '' }}
          </b-table-column>

        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>Nothing here. Add a new project!</p>
            </div>
            </section>
        </template>
      </b-table>

    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import utils from '../utils';
import Navigation from './Navigation';
import Sidebar from './Sidebar';
import EditProjectComponent from './EditProject';

export default {
  name: 'Projects',
  components: {
    Navigation,
    Sidebar,
  },
  data() {
    return {
      currentUser: null,
      selected: null,
      projects: [],
      filteredProjects: [],
      isEmpty: false,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'desc',
      currentPage: 1,
      perPage: 10,
      searchTerm: '',
    };
  },
  mounted() {
    this.currentUser = firebase.auth().currentUser;
    this.getProjects();
    this.verifyIdToken();
    //this.checkFirstLogin();
  },
  methods: {
    search() {
      this.filteredProjects = this.projects.filter(project => project.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
    },
    verifyIdToken() {
      firebase.auth().currentUser.getIdToken(true).then((idToken) => {
        // console.log(idToken);
      }).catch((error) => {
        // console.log(error);
      });
    },
    // checkFirstLogin() {
    //   firebase.database().ref('users/' + this.currentUser.uid + '/registered').once('value').then((snapshot) => {
    //     if (snapshot.val() === null) {
    //       this.setUserFirstLogin();
    //     }
    //   });
    // },
    // setUserFirstLogin() {
    //   var firstLoginDate = Date.now();
    //   var updates = {};
    //   updates['/users/' + this.currentUser.uid + '/registered'] = firstLoginDate;

    //   firebase.database().ref().update(updates);
    // },
    createNewProject(projectName) {
      const newProjectKey = firebase.database().ref().child('projects').push().key;

      let userProject = {
        id: newProjectKey,
        name: projectName,
        description: '',
        created: Date.now(),
      };

      let project = {
        data: null,
        user: this.currentUser.uid,
      };

      var updates = {};
      updates['/projects/' + newProjectKey] = project;
      updates['/users/' + this.currentUser.uid + '/projects/' + newProjectKey] = userProject;

      firebase.database().ref().update(updates).then(() => {
        this.openProject(newProjectKey);
      });
    },
    newProjectDialog() {
      this.$dialog.prompt({
        message: 'Set a project name',
        confirmText: 'Create',
        inputAttrs: {
          placeholder: 'Your great project',
          maxlength: 30,
        },
        onConfirm: (value) => {
          if (value.length >= 3) {
            this.createNewProject(value);
          } else {
            this.$toast.open({
              message: 'Please set a project name',
              type: 'is-danger',
            });
          }
        },
      });
    },
    getProjects() {
      this.projects = [];
      firebase.database().ref('users/' + this.currentUser.uid).once('value').then((snapshot) => {
        if (snapshot.val() !== null) {
          const projects = snapshot.val().projects;
          for (const id in projects) {
            this.projects.push(projects[id]);
          }
          this.filteredProjects = this.projects;
        }
      });
    },
    openProject(projectId) {
      const url = `${document.location.origin}/editor/?id=${projectId}`;
      document.location.replace(url);
    },
    editProject(project) {
      this.$modal.open({
        parent: this,
        component: EditProjectComponent,
        hasModalCard: true,
        width: 800,
        props: {
          project,
        }
      });
    },
    deleteProject(project) {
      this.$dialog.confirm({
        message: 'Delete this project?',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => {
          var updates = {};
          updates['/projects/' + project.id] = {};
          updates['/users/' + this.currentUser.uid + '/projects/' + project.id] = {};

          firebase.database().ref().update(updates).then(() => {
            this.getProjects();
            this.$toast.open({
              message: 'Successfully deleted project!',
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue